import { z } from 'zod';

// Ports features/survey/actions.schema.ts. The Next schemas parsed flat
// `FormData` fields (`b_question_<locale>` / `a_question_<locale>`) with
// `parseWithZod`; here the admin forms are controlled React state, so the
// per-locale texts are grouped into `beforeQuestion` / `afterQuestion` records
// and the numeric ids stay numbers in the caller. `en` is required for the
// description and for both the before/after text, matching the Next `.min(1)`
// rules; the other locales are optional.

export const addSurveySchema = z.object({
  name: z.string().min(1),
});

export type AddSurveyInput = z.infer<typeof addSurveySchema>;

// Per-locale text; `en` is required, every other locale may be empty.
export const questionTextSchema = z.object({
  en: z.string().min(1),
  sv: z.string(),
  no: z.string(),
  dk: z.string(),
  de: z.string(),
  fr: z.string(),
  fi: z.string(),
  pt: z.string(),
  pl: z.string(),
});

export type QuestionText = z.infer<typeof questionTextSchema>;

export const questionSchema = z.object({
  description: z.string().min(1),
  beforeQuestion: questionTextSchema,
  afterQuestion: questionTextSchema,
});

export type QuestionInput = z.infer<typeof questionSchema>;

export const addQuestionToSurveySchema = z.object({
  question: z.number().gte(0),
});

export type AddQuestionToSurveyInput = z.infer<
  typeof addQuestionToSurveySchema
>;
